package com.kinoshazam.model

import kotlinx.serialization.Serializable

sealed interface Route {

    /**
    Interface for modal destination if you want to open screen as dialog
    There will be use another nav controller
     */
    sealed interface Dialog : Route {

        @Serializable
        data class Details(val id: Int, val isSerial: Boolean) : Dialog

        @Serializable
        data class WebPlayer(
            val url: String,
            val title: String = "",
            val videoId: Int = -1,
            val isTvShow: Boolean = false,
            val seasonNumber: Int = 0,
            val episodeNumber: Int = 0,
            val imdbId: String = "",
            val imageUrl: String = "",
            val backdropUrl: String = "",
        ) : Dialog

        @Serializable
        data object Search : Dialog

        @Serializable
        data object Profile : Dialog

        @Serializable
        data object Login : Dialog

        @Serializable
        data class OtpScreen(
            val email: String,
            val flowType: String,
        ) : Dialog

        @Serializable
        data class ChangePassword(val token: String?) : Dialog

        @Serializable
        data class ForgotPassword(val email: String?) : Dialog

        @Serializable
        data class Decide(val partyCode: String = "") : Dialog

        @Serializable
        data class Person(val personId: Int) : Dialog
    }

    @Serializable
    data object Main : Route

    @Serializable
    data object AppInfo : Route

    @Serializable
    data object History : Route

    @Serializable
    data object Update : Route

    @Serializable
    data class VideoPlayer(val url: String) : Route

    @Serializable
    data class AllVideo(
        val screenType: String,
        val title: String,
        val genre: String,
        val personId: Int = -1,
    ) : Route
}
